module.exports = __webpack_public_path__ + "img/digital_jicheng.9658147e.png";